import {
    FaceLandmarker,
    FilesetResolver,
    DrawingUtils,
} from "@mediapipe/tasks-vision";

let faceLandmarkerInstance = null;
let runningMode = "VIDEO";

export async function preloadFaceLandmarker() {
    if (faceLandmarkerInstance) return faceLandmarkerInstance;

    const filesetResolver = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm");

    faceLandmarkerInstance = await FaceLandmarker.createFromOptions(filesetResolver, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`, delegate: navigator.gpu ? "GPU" : "CPU",
        },
        outputFaceBlendshapes: false,
        runningMode,
        numFaces: 1,
    });

    return faceLandmarkerInstance;
}

export function getFaceLandmarker() {
    if (!faceLandmarkerInstance) throw new Error("FaceLandmarker chưa preload!");
    return faceLandmarkerInstance;
}

export async function getFaceLandmarkerSafe() {
    if (!faceLandmarkerInstance) {
        console.warn("⚠️ FaceLandmarker chưa được preload, đang tiến hành preload lại...");
        return await preloadFaceLandmarker();
    }
    return faceLandmarkerInstance;
}